import { Component, Output, EventEmitter, ViewEncapsulation, signal, inject } from '@angular/core';
import { AppSettings } from '@ukam/shell/config';
import { CoreService } from '@ukam/shell/services/core.service';
import { TablerIconComponent } from '@ukam/ui-kit/icon/tabler-icon.component';
import { MaterialModule } from '@ukam/ui-kit/material.module';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-customizer',
  imports: [
    TablerIconComponent,
    MaterialModule,
    FormsModule,
    NgScrollbarModule,
    TranslocoModule
  ],
  templateUrl: './customizer.component.html',
  encapsulation: ViewEncapsulation.None
})
export class CustomizerComponent {
  private settings = inject(CoreService);


  options = this.settings.getOptions();



  @Output() optionsChange = new EventEmitter<AppSettings>();
  hideSingleSelectionIndicator = signal(true);
  setTheme(theme: string) {
    this.settings.setOptions({ theme });
    this.emitOptions();
  }

  setColor(color: string) {
    this.settings.setOptions({ activeTheme: color });
    this.emitOptions();
  }

  setDir(dir: 'ltr' | 'rtl') {
    this.settings.setOptions({ dir: dir });
    this.emitOptions();
  }

  setSidebar(sidenavOpened: boolean) {
    this.settings.setOptions({ sidenavOpened: sidenavOpened });
    this.emitOptions();
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }
}

